export default __webpack_public_path__ + "static/accent-product-da9937dbe8e980d75f72a618d05313e5.png";